import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomTable from "../CustomTable";
import CustomButton from "../CustomButton";
import moment from "moment";
import DatePicker from "../FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { storeColumns } from "../Columns/Vouchers/AllVouchers";
import { l1Columns } from "../Columns/Vouchers/RejectedVouchers";
import { useAuth } from "../../contexts/AuthContext";
import { downloadReports, downloadReportsFun, getArrayOfSelectedStoresCode } from "../../utils/helpers";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { toast } from "react-toastify";

const RejectedVouchers = () => {
  const { data = [], apiCall } = useApi();
  const {data: fileData,  apiCall: fileDownload } = useApi();
  const {data: fileStoreData,  apiCall: fileDownloadAtStore } = useApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const loc = useLocation()
  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );
  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );
  const {
    user: { userLabel = "" },
    selectedStores,
    storeDropdownState,
    currentStoreSelect, 
    setCurrentStoreSelect
  } = useAuth();

  const { name: storeName } =
    selectedStores?.storeDetails || selectedStores?.[0] || {name:""};

  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [tableData, setTableData] = useState();
  const getRecordsInFlightRef = useRef(false);
  const lastFetchKeyRef = useRef("");

  let pathVar = loc?.pathname?.split("/") || ""
  let subVoucherPath = pathVar[pathVar.length - 1]

  // let currentSubVoucherData = data?.storeWiseRecordsResponses?.find(i => i.storeName == currentStoreSelect)?.documents

  // useEffect(() => {
  //   if(subVoucherPath == "sub-voucher") {
  //     setTableData(currentSubVoucherData || [])
  //   } 
  // }, [data])

  // useEffect(() => {
  //   if(subVoucherPath == "vouchers"){
  //     setTableData(data?.storeWiseRecordsResponses)
  //   } else {
  //     setTableData(currentSubVoucherData)
  //   }
  // }, [subVoucherPath])

  const mapSubVoucherData = () =>{
    let currentSubVoucherData = [];
      if(currentStoreSelect){
        currentSubVoucherData = data?.storeWiseRecordsResponses?.find(
          (i) => i.storeName === currentStoreSelect
        )?.documents;
      }else if(storeName && storeName !== 'All'){
        currentSubVoucherData = data?.storeWiseRecordsResponses?.find(
          (i) => i.storeName === storeName
        )?.documents;
      }else{
        currentSubVoucherData = data?.storeWiseRecordsResponses?.length > 0 ? data?.storeWiseRecordsResponses[0]?.documents : []
      }
      return currentSubVoucherData;
  }

  useEffect(() => {
    if (subVoucherPath === "sub-voucher") {
      setTableData(mapSubVoucherData() || []);
    }
  }, [data]);

  useEffect(() => {
    if (subVoucherPath === "vouchers") {
      setTableData(data?.storeWiseRecordsResponses);
    } else {
      setTableData(mapSubVoucherData());
    }
  }, [subVoucherPath]);

  const voucherApiCall = (start, end) => {
    const safeStart = start || new Date();
    const safeEnd = end || safeStart;
    const storeCodes = getArrayOfSelectedStoresCode(selectedStores, storeDropdownState);
    const requestKey = JSON.stringify({
      startDate: moment(safeStart).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(safeEnd).endOf("d").format("YYYY-MM-DD HH:mm:ss"),
      metadataSchemaId: 4,
      status: "REJECTED",
      storeCodes: Array.isArray(storeCodes) ? [...storeCodes].sort() : [],
    });
    if (
      getRecordsInFlightRef.current &&
      lastFetchKeyRef.current === requestKey
    ) {
      return;
    }
    getRecordsInFlightRef.current = true;
    lastFetchKeyRef.current = requestKey;

    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          startDate: safeStart,
          endDate: safeEnd,
        }).toString(),
      },
      { replace: true }
    );
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(safeStart).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 4,
          endDate: moment(safeEnd)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: "",
          status: "REJECTED",
          storeCodes
          // storeCodes: selectedStores?.storeDetails?.storeCode
          //   ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
          //   : userLabel == "Store" ? null : [storeCode],
        },
        method: "post",
        onSuccess: () => {
          getRecordsInFlightRef.current = false;
        },
        onFail: () => {
          getRecordsInFlightRef.current = false;
        },
        onError: () => {
          getRecordsInFlightRef.current = false;
        },
        processData: userLabel === "Store",
        accessor: "storeGetResponse",
        itemAccessor: "dataModalRecordsResponse",
      });
  };

  const storeFetchDependencyKey = useMemo(() => {
    const selectedCode =
      selectedStores?.storeDetails?.storeCode ||
      selectedStores?.storeCode ||
      selectedStores?.value ||
      "";
    const dropdownCount = Array.isArray(storeDropdownState)
      ? storeDropdownState.length
      : storeDropdownState
      ? 1
      : 0;
    return `${selectedCode}|${dropdownCount}`;
  }, [
    selectedStores?.storeDetails?.storeCode,
    selectedStores?.storeCode,
    selectedStores?.value,
    Array.isArray(storeDropdownState) ? storeDropdownState.length : 0,
  ]);

  useEffect(() => {
    voucherApiCall(startDate, endDate);
  }, [storeFetchDependencyKey]);

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end) voucherApiCall(start, end);
  };

  const onClickChangeData = (data) => {
    setTableData(data);
  };

  const nonStoreColumns = useMemo(
    () =>
      l1Columns({
        tableData,
        userLabel,
        extraColumns: (subVoucherPath == "sub-voucher")
          ? [
              {
                Header: "V.ID",
                accessor: "id",
                Cell: (props) => {
                  const id = props?.row?.original?.id;
                  const { pendingDocs = [], approvedDocs = [], rejectedDocs = [] } = props?.row?.original
                  return (
                    <div
                    className={
                      rejectedDocs.length > 0 &&
                      `${"underline underline-offset-4 cursor-pointer"}`
                    }
                    style={{ color: rejectedDocs.length > 0 ? "blue" : "" }}
                      onClick={() => {
                        if(rejectedDocs.length > 0){
                        navigate(`/vouchers/${id}`, {
                          state: { ...props.row?.original, type: "Rejected" },
                        })
                      }
                      }
                      }
                    >
                      {id}
                    </div>
                  );
                },
              },
            ]
          : [
              {
                Header: "Store Name",
                accessor: "storeName",
                Cell: (props) => {
                  const store_name = props?.row?.original?.storeName;
                  return (
                    <div
                      className="cursor-pointer underline underline-offset-4"
                      style={{ color: "blue" }}
                      onClick={() => {
                        navigate(
                          {
                            pathname: "sub-voucher",
                            search: createSearchParams({
                              startDate: startDate,
                              endDate: endDate,
                            }).toString(),
                          }
                        );
                        setCurrentStoreSelect(store_name)
                        onClickChangeData(props?.row?.original?.documents);
                      }}
                    >
                      {store_name}
                    </div>
                  );
                },
              },
            ],
      }),
    [tableData, startDate, endDate, userLabel]
  );
  const memoStoreColumns = useMemo(() => storeColumns({ navigate }), []);

  const getStoreCodeByName = (storeName) => {
    return storeDropdownState.find(i => i.name == storeName)?.storeCode
  }

  const downloadVoucherAtStoreLevel = () => {
    const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileDownloadAtStore({
      url: `${apiUrls.dmsService.downloadVoucherStoreLevel}`,
      dataToSend: {
        storeCodes: selectedCheckBoxes?.map((i) =>
          getStoreCodeByName(i.original.storeName)
        ),
        status: "Rejected",
        metadataSchemaId: 4,
        endDate: et,
        startDate: st,
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if (status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "RejectedVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  }

  const onClickDownloadFile = () => {
    // const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    // const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    fileDownload({
      url: `${apiUrls.dmsService.getDownloadVoucherReport}`,
      // dataToSend: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
      dataToSend: {
        voucherIds: userLabel == "Store" ? selectedCheckBoxes?.map(i => Number(i.original.vid)):  selectedCheckBoxes?.map(i => Number(i.original.id)) || [],
        status: "Rejected",
      },
      method: "post",
      responseType: "blob",
      responseData: (res) => {
        const { data = "", status = null } = res || {};
        const contentType = res?.headers?.["content-type"];
        const contentDisposition = res?.headers["content-disposition"];
        const fileNameMatch =
          contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = fileNameMatch
          ? fileNameMatch[1]
          : "downloaded-file.xlsx";
        if(status === 200) {
          toast.success("Download File Successfully");
          downloadReportsFun(data, "RejectedVoucher.xlsx", contentType);
        } else {
          toast.success("Something Went Wrong");
        }
      },
    });
  };

  return (
    <div className="flex flex-col py-2">
      <div className="flex justify-end mt-2 mb-8">
        <div className="flex items-center gap-x-3">
          <div className="font-size-medium">Date Range</div>

          <DatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onChangeDate}
            maxDate={new Date()}
            dateRange
          />
        </div>
      </div>
      <CustomTable
        data={
          tableData
            ? tableData
            : userLabel === "Store"
            ? data
            : data?.storeWiseRecordsResponses || []
        }
        columns={userLabel === "Store" ? memoStoreColumns : nonStoreColumns}
        showCheckboxes={false}
        onCheckboxSelect={(selectedCheckBoxes) => {
          const data1 =
            userLabel === "Store"
              ? data
              : data?.storeWiseRecordsResponses || [];
          if (data1?.length) {
            setSelectedCheckBoxes(selectedCheckBoxes);
          }
        }}
        centerAlignedColumns={[
          "l1_status",
          "l2_status",
          "amount",
          "ac_status",
          "approved_amount",
        ]}
        // isGlobalSearchEnable
        // globalSearchPosition={{
        //   top: "-63px",
        //   left: 0,
        // }}
      />
      {/* <CustomButton
        title="Download"
        wrapperClassName={`self-end !px-10 mt-5 ${
          selectedCheckBoxes?.length > 0 ? "" : "disabled-kv"
        }`}
        onClick={() => {
          if(selectedCheckBoxes?.map((item) => item?.original)[0]?.storeName){
            downloadVoucherAtStoreLevel()
          } else {
            onClickDownloadFile()
          }
        }}  
      /> */}
    </div>
  );
};

export default RejectedVouchers;
